module.exports = __webpack_public_path__ + "assets/img/TMSP1-1.c13965e8.jpg";